import { useQuery } from '@tanstack/react-query';
import type { FoodNotificationSettingsDto } from '../../../models/settings/admin/food-notification-settings.dto';
import apiRequest from '../../../services/apiWrapper';
import { FOOD_PAYMENT_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';

async function getFoodNotificationsSettings() {
  const response = await apiRequest.get<FoodNotificationSettingsDto>(
    FOOD_PAYMENT_NOTIFICATION_URL
  );

  return response.data;
}

export function useGetFoodNotificationsSettings() {
  return useQuery({
    queryKey: ['food-notification-settings'],
    queryFn: getFoodNotificationsSettings,
  });
}
